import { __module as e } from "../../../../../_virtual/jsx-runtime2.js";
import { __require as t } from "./cjs/react-jsx-runtime.production.js";
import { __require as i } from "./cjs/react-jsx-runtime.development.js";
var r;
function m() {
  return r ? e.exports : (r = 1, process.env.NODE_ENV === "production" ? e.exports = t() : e.exports = i(), e.exports);
}
export {
  m as __require
};
